import { render, staticRenderFns } from "./company-page.vue?vue&type=template&id=ab6fff7c&scoped=true"
import script from "./company-page.vue?vue&type=script&lang=js"
export * from "./company-page.vue?vue&type=script&lang=js"
import style0 from "./company-page.vue?vue&type=style&index=0&id=ab6fff7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab6fff7c",
  null
  
)

export default component.exports